import { render, staticRenderFns } from "./RegistrationViewSlots.vue?vue&type=template&id=4785631c&scoped=true&"
import script from "./RegistrationViewSlots.vue?vue&type=script&lang=js&"
export * from "./RegistrationViewSlots.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationViewSlots.vue?vue&type=style&index=0&id=4785631c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4785631c",
  null
  
)

export default component.exports